module.exports = __webpack_public_path__ + "static/media/login_background.3a1360d9.png";